export default "__VITE_ASSET__BTL_Sr8q__"